{
	"_comment": "This file is updated by the build process. Do not edit it manually.",
	"version": "1.72.2",
	"hash": "714f9467c8e01c5ddd66ba2e156e9bc86c60bd86"
}
